import { FC } from 'react';
import styled from 'styled-components';
import { Banner } from 'ui/banner';
import { BannerVariants } from 'ui/banner/types';
import { InfoFill16 } from 'ui/icons/aurora/16px/InfoFill16';
import { Link } from 'ui/links';

const StyledBanner = styled(Banner)`
grid-area: banner;
width: 100%;
border-radius: 0;
`;

interface ListHeaderProps {
  actionUrl: string;
  actionTitle: string;
  description: string;
}

export const ListBanner: FC<ListHeaderProps> = ({ actionUrl, actionTitle, description }) => {
  return (
    <StyledBanner
      Icon={<InfoFill16 />}
      variant={BannerVariants.INFO}
      BannerActions={
        <Link href={actionUrl} target="_blank" variant="inherit" hasOpenNewTabIcon>
          {actionTitle}
        </Link>
      }
    >
      {description}
    </StyledBanner>
  );
};
